var map = {
	"./ArrowResulsCard.svg": [
		5927,
		927
	],
	"./alreadyVoted.svg": [
		5504,
		504
	],
	"./arrow.svg": [
		5090,
		90
	],
	"./back.svg": [
		7911,
		911
	],
	"./copy.svg": [
		7918,
		918
	],
	"./createVotPopup.svg": [
		9055,
		55
	],
	"./delete-ballot-popup.svg": [
		5309,
		309
	],
	"./eroare-404.svg": [
		9665,
		665
	],
	"./lock.svg": [
		3914,
		914
	],
	"./logo-white.svg": [
		4758,
		758
	],
	"./logo.svg": [
		3190,
		190
	],
	"./noUserStatus.svg": [
		3793,
		793
	],
	"./noVotes.svg": [
		9408,
		408
	],
	"./pencil.svg": [
		1265,
		265
	],
	"./pointing.svg": [
		4272,
		272
	],
	"./popup.svg": [
		1519,
		519
	],
	"./popupicon.svg": [
		6473,
		473
	],
	"./trash-solid 1.svg": [
		1722,
		722
	],
	"./vote-count.svg": [
		5537,
		537
	],
	"./voteTypes/multipleChoice.svg": [
		1385,
		385
	],
	"./voteTypes/public.svg": [
		6619,
		619
	],
	"./voteTypes/secret.svg": [
		7964,
		964
	],
	"./voteTypes/singleChoice.svg": [
		2554,
		554
	],
	"./votingTemplates/dollar.svg": [
		6469,
		469
	],
	"./votingTemplates/hammer.svg": [
		81,
		81
	],
	"./votingTemplates/human.svg": [
		3558,
		558
	],
	"./votingTemplates/kebab.svg": [
		3926,
		926
	],
	"./votingTemplates/lynch.svg": [
		6598,
		598
	],
	"./votingTemplates/paper.svg": [
		842,
		47
	],
	"./votingTemplates/plus.svg": [
		3165,
		165
	],
	"./x.svg": [
		4118,
		118
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 900;
module.exports = webpackAsyncContext;